<div class="metadata-content d-flex flex-column ls-m1" data-cy="tender-detail-metadata">
  <!-- dates de publication et de fin -->
  <div class="metadata-group dates-container">
    <div class="d-flex align-items-center gap-4px">
      <i class="ph-fill ph-calendar-check flex-center-start pe-1"></i>
      <span>
        {{ 'tenders.metadata.from' | translate }}
      </span>
      <!--date de publication définie-->
      <span *ngIf="tenderDetail.indexationDate.getTime() > 0" class="important ls-m2">
        {{ tenderDetail.indexationDate | date: 'dd/MM/yyyy' }}</span
      >
      <!--date de publication nulle ou undef-->
      <span *ngIf="tenderDetail.indexationDate.getTime() === 0" class="null-value ls-m2">
        {{ 'tenders.unset-values.undetected' | translate }}</span
      >
    </div>

    <div class="d-flex gap-4px">
      <i class="ph-fill ph-calendar-dot flex-center-start pe-1"></i>
      <span>
        {{ 'tenders.metadata.to' | translate }}
      </span>
      <!--date de fermeture définie-->
      <ng-container *ngIf="tenderDetail.closingDate && tenderDetail.closingDate.getTime() > 0">
        <span *ngIf="tenderDetail.closingDate && hasNonZeroTime(tenderDetail.closingDate)" class="important ls-m2">
          {{ tenderDetail.closingDate | date: 'dd/MM/yyyy à HH:mm' }}</span
        >
        <span *ngIf="tenderDetail.closingDate && !hasNonZeroTime(tenderDetail.closingDate)" class="important ls-m2">
          {{ tenderDetail.closingDate | date: 'dd/MM/yyyy' }}</span
        >
      </ng-container>
      <!--date de fermeture nulle ou undef-->
      <span *ngIf="tenderDetail.tenderType === TenderTypesEnum.ATTRIBUTION">-</span>
      <span
        *ngIf="
          tenderDetail.tenderType !== TenderTypesEnum.ATTRIBUTION &&
          (!tenderDetail.closingDate || (tenderDetail.closingDate && tenderDetail.closingDate?.getTime() === 0))
        "
        class="null-value"
      >
        {{ 'tenders.unset-values.undetected' | translate }}
      </span>
    </div>
  </div>

  <!--Attributaires et montant-->
  @if (tenderDetail.assignees || tenderDetail.amount) {
    <div class="assignees-and-amount-content">
      @if (
        tenderDetail.assignees &&
        tenderDetail.assignees?.length &&
        (tenderDetail?.tenderType === TenderTypesEnum.ATTRIBUTION || tenderDetail?.tenderType === TenderTypesEnum.RECTIFICATIF)
      ) {
        <app-tender-assignees
          [styleClass]="'dark'"
          [tender]="tenderDetail"
          [assigneePopOverId]="assigneePopOverId"
          (toggleAssigneePopover)="toggleOverlay($event)"
          (closeAssigneePopover)="closeOverlay()"
        />
      }
      @if (tenderDetail.amount) {
        <div class="amount">
          <div
            class="amount-compact d-flex align-items-center"
            [ngbTooltip]="
              tenderDetail.tenderType === TenderTypesEnum.ATTRIBUTION || tenderDetail?.tenderType === TenderTypesEnum.RECTIFICATIF
                ? tenderAmountTooltip
                : null
            "
            tooltipClass="custom-tooltip-attribution"
            placement="bottom auto"
            container="body"
            [openDelay]="300"
          >
            <i class="ph-fill ph-coins color-basic-500"></i>
            <app-tender-amount compactVersion largeFont [amount]="tenderDetail.amount" />
          </div>
          <!--Tooltip affichant montants.-->
          <ng-template #tenderAmountTooltip>
            <div class="ph-text-align-left d-flex w-100">
              <span class="fw-600">{{ 'tenders.amount' | translate }}</span>
              <app-tender-amount class="pdl-4px" [amount]="tenderDetail.amount" />
            </div>
          </ng-template>
        </div>
      }
    </div>
  }

  <div *ngIf="tenderDetail.estimatedEndDate" class="d-flex metadata-item ls-m2">
    <i class="flex-center-start ph-bold ph-clock-clockwise pe-1"></i>
    <span>{{ 'tenders.metadata.estimated-end-date' | translate }}</span>
    <span class="fw-semibold">{{
      tenderDetail.estimatedEndDate.toLocaleDateString('fr-FR', {
        month: 'long',
        year: 'numeric',
      })
    }}</span>
  </div>

  <div class="inquirers-and-territories-container">
    <i class="ph-fill ph-users"></i>
    <app-searchable-entity
      [styleClass]="'dark'"
      class="inquirers-container"
      [attributeName]="'organisation'"
      [baseUrl]="environment.appBaseUrl + '/tenders/search'"
      [entityName]="tenderDetail.inquirers.join(', ') || 'tenders.unset-values.inquirers' | translate | removeDepartmentNumbers"
    />
    <app-inline-territories-display [territories]="tenderDetail.territories" [styleClass]="'dark'" />
  </div>
</div>
